import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import {
  IVendorAccess,
  Vendor,
  VendorRiskSummary,
} from '../../../core/store/digital-footprint/vendors/models/Vendors';
import {
  FilterProps,
  PagedResponse,
} from '../../../core/store/general/models/general';

@Injectable({
  providedIn: 'root',
})
export class VendorsService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  /**
   * @param includePlatformProviders `false` hides the platform provider's own apps
   * (GoogleFirstParty / MicrosoftFirstParty). Omitted = the API default, everything listed.
   * No caller passes it yet; the vendor view keeps its current presentation until the
   * badge/filter release.
   */
  getVendors(
    props: FilterProps,
    includePlatformProviders?: boolean,
  ): Observable<PagedResponse<Vendor>> {
    const params: string[] = [];
    if (includePlatformProviders !== undefined)
      params.push(`includePlatformProviders=${includePlatformProviders}`);
    if (props.searchTerm)
      params.push(`searchTerm=${props.searchTerm.toLowerCase()}`);
    if (props.sortBy) params.push(`sortBy=${props.sortBy}`);
    if (props.sortBy && props.sortDescending !== undefined)
      params.push(`sortDirection=${props.sortDescending ? 'desc' : 'asc'}`);
    if (props.pageNumber) params.push(`pageNumber=${props.pageNumber}`);
    if (props.filters) params.push(props.filters);
    const query = params.length ? `?${params.join('&')}` : '';

    return this.http.get<PagedResponse<Vendor>>(
      `${this.baseApiUrl}/digital-footprint/vendors${query}`,
    );
  }

  getVendorRiskSummary(): Observable<VendorRiskSummary> {
    return this.http.get<VendorRiskSummary>(
      `${this.baseApiUrl}/digital-footprint/vendors/risk-summary`,
    );
  }

  getVendorAccess(companyVendorId: string): Observable<IVendorAccess> {
    return this.http.get<IVendorAccess>(
      `${this.baseApiUrl}/digital-footprint/vendors/${companyVendorId}/overview`,
    );
  }
}
